import { render } from "./LeaderboardPage.vue?vue&type=template&id=e0e4623e&scoped=true"
import script from "./LeaderboardPage.vue?vue&type=script&lang=js"
export * from "./LeaderboardPage.vue?vue&type=script&lang=js"

import "./LeaderboardPage.vue?vue&type=style&index=0&id=e0e4623e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0e4623e"]])

export default __exports__